import Api from "./api";

class ClientApi extends Api {
	constructor(token, clientId, onUnauthorized) {
		super(token, clientId, onUnauthorized);
		this.baseUrl = this.getBaseUrl() + "client/1/";
	}

	getClient(onSuccess, onError) {
		this.Get(this.baseUrl, onSuccess, onError);
	}

	updateClient(clientData, onSuccess, onError) {
		this.Put(this.baseUrl, clientData, onSuccess, onError);
	}
}

export default ClientApi;
